import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.representation)?_c('span',[_c(VIcon,{staticClass:"fielddate-calendar-icon",attrs:{"small":""}},[_vm._v("\n    mdi-calendar\n  ")]),_c('span',{class:_vm.class_limit_time,staticStyle:{"padding-left":".2em"}},[_vm._v(_vm._s(_vm.representation))])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }